import SectionEditor from '../components/SectionEditor';

export default function ReportsEditor(){
  const fields = [
    {
      key: 'monthsBack',
      label: 'Zeitraum der Reservierungsberichte',
      type: 'select',
      numeric: true,
      options: [1, 2, 3, 4, 5, 6].map((n) => ({
        value: n,
        label: n === 1 ? 'Letzter Monat' : `Letzte ${n} Monate`,
      })),
      help: 'Nach jeder neuen Reservierung werden PDF-Berichte per E-Mail verschickt. Sie enthalten alle Reservierungen aus diesem Zeitraum (gerechnet ab dem Zeitpunkt der Reservierung).',
    },
  ];
  const defaults = {
    monthsBack: 2,
  };
  return <SectionEditor sectionKey="reports" title="Berichte" fields={fields} defaults={defaults} />;
}
